import { render, staticRenderFns } from "./activate-qq-dialog.vue?vue&type=template&id=1638c809&"
import script from "./activate-qq-dialog.vue?vue&type=script&lang=js&"
export * from "./activate-qq-dialog.vue?vue&type=script&lang=js&"
import style0 from "./activate-qq-dialog.vue?vue&type=style&index=0&id=1638c809&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports